/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import {
  DownloadOutlined,
  InfoCircleFilled,
  MoreOutlined,
  PrinterOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import {
  Col,
  Row,
  Image,
  Input,
  Tabs,
  Menu,
  Dropdown,
  message,
  Tag,
  Tooltip,
  Badge,
  Alert,
  Space,
  Button,
  Popover,
} from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { appConfig, themeConfig } from 'config'
import { StockListReq, DeleteStockReq, StockListData, StockConfigDetailReq } from 'Store/stock/types'
import { stockListAPI, deleteStockAPI, getStockConfigDetailAPI } from 'Store/stock/api'
import {
  selectStockList,
  selectStockListEvent,
  selectStockActionEvent,
  selectCountData,
  selectStockConfigDatail,
} from 'Store/stock/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/stock/actions'
import {
  currentDateTimeThaiformat,
  getConfigByKey,
  getMenuSelect,
  getRequestString,
  numberWithComma,
} from 'helpers/format'
import { DefaultStatus, DocumentConfigKey, ImageFallback, menuStock } from 'helpers/constanst'
import { ConfirmDailog, LoadingView } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import GrnHistory from './detail'
import AdjustDrawer from './AdjustStock'
import StockMovement from './StockMovement'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import theme, { MyTheme } from 'Components/common/Theme'
import downloadCSVFile from 'helpers/export'
import Axios from 'axios'
import { APIPath } from 'services/APIPath'
import Category from 'Components/form/Category'
import { selectList as selectCateList } from 'Store/categories/selector'
import { categoriesListAPI } from 'Store/categories/api'
import { manufactuerListAPI } from 'Store/manufactuer/api'
import { MenuPrints, SelectItem } from 'Components/form'
import { selectList as selectManufactuerList } from 'Store/manufactuer/selector'
import { getStaffPermission } from 'helpers/account'
import ProductBarcode from 'Components/utilities/ProductBarcodePrint'
import BarcodePDF from './BarcodePDF'
import ReactToPrint from 'react-to-print'
import { selectConfig, selectConfigList } from 'Store/pos/selector'
import ProductMultiUoms from 'Pages/Product/components/ProductMultiUoms'
import { MultiUom } from 'Store/product/types'

const { TabPane } = Tabs

type Props = {} & ReduxProps

const Stock: React.FunctionComponent<Props> = props => {
  const {
    currentUser,
    listEvent,
    list,
    event,
    categories,
    manufacturers,
    stockNotice,
    stockConfigDetail,
    configList,
  } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [stockMoveMentDrawer, setStockMoveMentDrawer] = useState(false)
  const [activeTab, setActiveTab] = useState('allocate' as 'allocate' | 'stock')
  const [grnHistory, setGrnHistory] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [exporting, setExporting] = useState(false)
  const [selectedStock, setSelectedStock] = useState(undefined as StockListData | undefined)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const permission = getStaffPermission()
  const hasManageOFStockPermission = permission && permission.includes('/manage-online-offline-stock')
  const hasManageStockOutPermission = permission && permission.includes('/manage-stock-out')
  const hasPurchasingHistoryPermission = permission && permission.includes('/get-purchasing-history')
  const hasStockMovemenPermission = permission && permission.includes('/stock-movement')
  const hasManagePermission =
    hasManageOFStockPermission ||
    hasManageStockOutPermission ||
    hasPurchasingHistoryPermission ||
    hasStockMovemenPermission
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct
  const [searchKeyword, setSearchKeyword] = useState('')
  const mid = currentUser?.activeMerchant?.id || 0
  const hasConfig = stockConfigDetail?.data?.length > 0
  const [productSelect, setProductSelect] = useState(undefined as StockListData | undefined)
  const [uomSelect, setUomSelect] = useState(undefined as any)
  const printPDF = useRef(null as any)
  const configData = getConfigByKey(configList, DocumentConfigKey.BARCODE)
  const config = configData && configData?.config_value && JSON.parse(configData?.config_value || '')

  const [filter, setFilter] = useState({
    keyword: '',
    status: '',
    categories: [] as number[],
    manufacturer_id: 0,
    order_by: 'product_option_id',
    sort: 'desc',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: StockListReq = {
      keyword: filter.keyword,
      out_of_stock: filter?.status === 'out_of_stock' ? true : false,
      min_of_stock: filter?.status === 'min_of_stock' ? true : false,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      order_by: filter.order_by || 'product_option_id',
      sort: filter.sort || 'desc',
    }

    if (filter?.manufacturer_id) {
      req.manufacturer_id = filter?.manufacturer_id
    }
    if (filter?.categories && filter?.categories[0]) {
      req.group_id = filter?.categories[0]
    }
    if (filter?.categories && filter?.categories[1]) {
      req.category_id = filter?.categories[1]
    }
    if (filter?.categories && filter?.categories[2]) {
      req.sub_category_id = filter?.categories[2]
    }
    dispatch(stockListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetMasterData = (): void => {
    const merchant_id = currentUser?.activeMerchant?.id || 0
    const token = currentUser.accessToken
    dispatch(
      categoriesListAPI(
        {
          merchant_id,
          include_child: true,
        },
        token,
      ),
    )

    dispatch(
      manufactuerListAPI(
        {
          merchant_id,
        },
        token,
      ),
    )
  }

  const onExport = (): void => {
    setExporting(true)
    const req: StockListReq = {
      keyword: filter.keyword,
      out_of_stock: filter?.status === 'out_of_stock' ? true : false,
      min_of_stock: filter?.status === 'min_of_stock' ? true : false,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      order_by: filter.order_by || 'product_option_id',
      sort: filter.sort || 'desc',
      export: true,
      all: true,
    }

    if (filter?.manufacturer_id) {
      req.manufacturer_id = filter?.manufacturer_id
    }
    if (filter?.categories && filter?.categories[0]) {
      req.group_id = filter?.categories[0]
    }
    if (filter?.categories && filter?.categories[1]) {
      req.category_id = filter?.categories[1]
    }
    if (filter?.categories && filter?.categories[2]) {
      req.sub_category_id = filter?.categories[2]
    }
    const endPoint = appConfig.backofficeEndpoint + APIPath.stockList
    const header = {
      headers: {
        Authorization: `Bearer ${currentUser.accessToken}`,
        'X-Mid': currentUser?.activeMerchant?.uuid || '',
        'X-Auth-Mid': currentUser?.activeMerchant?.id || 0,
      },
    }
    Axios.post(endPoint, req, header)
      .then((res: any) => {
        const reportData = res?.data
        let title = 'รายงานสินค้าคลังคลัง'
        if (req.min_of_stock) {
          title = 'รายงานแจ้งเตือนสินค้าใกล้หมด'
        }
        if (req.out_of_stock) {
          title = 'รายงานสินค้าหมด'
        }
        const fileName = `${title} ประจำวันที่ ${currentDateTimeThaiformat()}`
        downloadCSVFile(reportData, fileName)
        setExporting(false)
      })
      .catch(error => {
        setExporting(false)
        message.error({
          content: error?.response?.data?.error || 'เกิดข้อผิดพลาด ไม่สามารถ Export ข้อมูลได้',
          key: 'export-error',
        })
      })
  }

  const onExportBarcode = () => {
    const req: any = {
      mid: currentUser?.activeMerchant?.id || '',
      nopic: 1,
      group_id: (filter?.categories && filter?.categories[0]) || 0,
      category_id: filter?.categories[1] || 0,
      sub_category_id: filter?.categories[2] || 0,
    }
    const endPoint = appConfig.backofficeEndpoint + `/backend/api/v1/test-xxx?${getRequestString(req)}`
    window.open(endPoint, '_blank')
  }

  const onDelete = (id: number): void => {
    const req: DeleteStockReq = {
      id,
    }
    dispatch(deleteStockAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetStockConfig = (): void => {
    const req: StockConfigDetailReq = {
      mid,
    }
    dispatch(getStockConfigDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
      console.log('pagination onGetList')
    }
  }, [pagination])

  useEffect(() => {
    onGetMasterData()
    onGetStockConfig()
  }, [])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onGetList()
    console.log('onSuccess onGetList')
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
    console.log('onDeleteSuccess onGetList')
  }

  const onChangeTab = (key: string) => {
    onFilter('status', key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    const timer1 = setTimeout(() => onFilter('keyword', searchKeyword), 1000)
    return () => {
      clearTimeout(timer1)
    }
  }, [searchKeyword])

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter])

  const renderActionButton = (value: string, record: StockListData) => {
    if (!hasManagePermission) return

    return (
      <TextCenter>
        <Dropdown key="more" overlay={menu(record)} trigger={['click', 'hover']}>
          <ActionButton text="" icon={<MoreOutlined />} label="" action="edit" />
        </Dropdown>
      </TextCenter>
    )
  }

  const renderImage = (img: string[]) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderCategory = (group: any, record: StockListData) =>
    `${record.product_group || ''} / ${record.product_category || ''} / ${record.product_sub_category || ''}`

  const renderProductName = (value: string, record: StockListData) => {
    const isSameTitle = value == record.product_option_title
    const isBom = record?.bom === 1
    return (
      <>
        {value}
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
        {isBom && (
          <Tooltip
            title={
              <span>
                สต๊อกของสินค้ามีส่วนประกอบจะถูกคำนวนจาก จำนวนคงเหลือของส่วนประกอบที่ใช้ในการผลิต
                ทำให้ไม่สามารถตรวจสอบรายการนำเข้า และปรับสินค้าออกจากคงคลังได้
                เนื่องจากสต๊อกของสินค้าประเภทนี้ไม่ได้ผ่านกระบวนการจัดซื้อและรับเข้า
              </span>
            }
            placement="top"
            arrowPointAtCenter
          >
            <Tag icon={<InfoCircleFilled />} color={theme.colors.primary} style={{ cursor: 'pointer' }}>
              สินค้ามีส่วนประกอบ
            </Tag>
          </Tooltip>
        )}
      </>
    )
  }

  const renderProductPrice = (price: number) => {
    return <TextCenter>{numberWithComma(price || 0, true)}</TextCenter>
  }

  const renderProductStock = (quantity: number) => {
    const stockCount = quantity || 0
    const stock = numberWithComma(stockCount)
    return <TextCenter>{stockCount < 10 ? <StockMin>{stock}</StockMin> : stock}</TextCenter>
  }

  const barcode = (record: StockListData) => {
    const BarCodeContent = (
      <BarcodeWraper>
        {/* <ProductName>{record.product_title}</ProductName>
        <ProductPrice> ราคา {numberWithComma(record.offline_price, true)} บาท</ProductPrice> */}
        <ProductBarcode barcode={record.barcode} height={100} width={3} />
      </BarcodeWraper>
    )
    return (
      <PopoverContent>
        <Space direction="vertical">{record.barcode && BarCodeContent}</Space>
      </PopoverContent>
    )
  }

  const renderProductCode = (code: string, record: StockListData) => {
    return (
      <div style={{ textAlign: 'center' }}>
        {record.product_code || '-'}
        {record.barcode && barcode(record)}
      </div>
    )
  }

  const menu = (product: StockListData) => {
    const isBom = product?.bom === 1
    const uoms =
      product?.product_option?.uoms?.filter(
        item => item.barcode !== '' && item.status === DefaultStatus.ACTIVE,
      ) || []

    return (
      <Menu>
        {hasManageOFStockPermission && (
          <Menu.Item
            onClick={() => {
              setSelectedStock(product)
              setDrawer(true)
              setActiveTab('allocate')
            }}
          >
            ปรับจำนวนขาย Online / Offline
          </Menu.Item>
        )}
        {hasManageStockOutPermission && !isBom && (
          <Menu.Item
            onClick={() => {
              setSelectedStock(product)
              setDrawer(true)
              setActiveTab('stock')
            }}
          >
            ปรับสินค้าออกจากสินค้าคงคลัง
          </Menu.Item>
        )}
        {hasPurchasingHistoryPermission && !isBom && (
          <Menu.Item
            onClick={() => {
              setSelectedStock(product)
              setGrnHistory(true)
            }}
          >
            ตรวจสอบรายการนำเข้า
          </Menu.Item>
        )}
        {hasStockMovemenPermission && (
          <Menu.Item
            onClick={() => {
              setSelectedStock(product)
              setStockMoveMentDrawer(true)
            }}
          >
            การเคลื่อนไหวคลังสินค้า
          </Menu.Item>
        )}
        {product.barcode &&
          (uoms?.length > 1 ? (
            <Menu.SubMenu title="พิมพ์บาร์โค้ดสินค้า">
              {uoms.map((item, index) => (
                <Menu.Item
                  key={index}
                  onMouseDown={() => {
                    setUomSelect(item)
                    setProductSelect(product)
                  }}
                >
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <div>
                          {item.uom_name} (บาร์โค้ด: {item.barcode || ''})
                        </div>
                      )
                    }}
                    content={() => printPDF.current}
                    documentTitle={`${uomSelect?.barcode}`}
                  />
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ) : (
            <Menu.Item>
              <ReactToPrint
                trigger={() => {
                  return (
                    <DownloadTxt
                      onMouseDown={() => {
                        setUomSelect({
                          barcode: product?.barcode || '',
                          uom_name: product?.uom,
                          offline_price: product?.offline_price,
                        })
                        setProductSelect(product)
                      }}
                    >
                      พิมพ์บาร์โค้ดสินค้า
                    </DownloadTxt>
                  )
                }}
                content={() => printPDF.current}
                documentTitle={`${product.barcode}`}
              />
            </Menu.Item>
          ))}
      </Menu>
    )
  }

  const renderProductUom = (uom: string, product: StockListData) => {
    const uoms = product?.product_option?.uoms || []

    if (uoms.length <= 0) {
      return uom
    }

    return <ProductMultiUoms uoms={uoms} showBarcode />
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'product_code',
      key: 'product_code',
      sorter: true,
      render: renderProductCode,
      width: '140px',
      align: 'center',
    },
    {
      title: 'รูปสินค้า',
      dataIndex: 'product_option_photo',
      key: 'product_option_photo',
      width: '80px',
      sorter: true,
      render: renderImage,
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'product_title',
      key: 'product_title',
      sorter: true,
      render: renderProductName,
      width: '150px',
    },
    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'product_group',
      key: 'product_group',
      width: '120px',
      sorter: true,
      render: renderCategory,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      sorter: true,
    },
    {
      title: 'หน่วย',
      dataIndex: 'uom',
      key: 'uom',
      align: 'center',
      sorter: true,
      render: renderProductUom,
    },
    {
      title: <TextCenter>สต๊อกรวม</TextCenter>,
      dataIndex: 'quantity_all',
      key: 'quantity_all',
      render: renderProductStock,
      sorter: true,
    },
    {
      title: 'ออนไลน์',
      children: [
        {
          title: <TextCenter>ราคาขาย</TextCenter>,
          dataIndex: 'price',
          key: 'price',
          render: renderProductPrice,
          sorter: true,
        },
        {
          title: <TextCenter>คงเหลือ</TextCenter>,
          dataIndex: 'quantity',
          key: 'quantity',
          sorter: true,
          render: renderProductStock,
        },
      ],
    },
    {
      title: 'ออฟไลน์',
      children: [
        {
          title: <TextCenter>ราคาขาย</TextCenter>,
          dataIndex: 'offline_price',
          key: 'offline_price',
          sorter: true,
          render: renderProductPrice,
        },
        {
          title: <TextCenter>คงเหลือ</TextCenter>,
          dataIndex: 'quantity_offline',
          key: 'quantity_offline',
          sorter: true,
          render: renderProductStock,
        },
      ],
    },
    {
      title: '',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const columnsWithOutOnline = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'product_code',
      key: 'product_code',
      sorter: true,
      render: renderProductCode,
      width: '140px',
      align: 'center',
    },
    {
      title: 'รูปสินค้า',
      dataIndex: 'product_option_photo',
      key: 'product_option_photo',
      width: '80px',
      sorter: true,
      render: renderImage,
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'product_title',
      key: 'product_title',
      sorter: true,
      render: renderProductName,
      width: '150px',
    },
    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'product_group',
      key: 'product_group',
      width: '250px',
      sorter: true,
      render: renderCategory,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      sorter: true,
    },
    {
      title: 'หน่วย',
      dataIndex: 'uom',
      key: 'uom',
      align: 'center',
      sorter: true,
      render: renderProductUom,
    },
    {
      title: <TextCenter>สต๊อก</TextCenter>,
      dataIndex: 'quantity_all',
      key: 'quantity_all',
      render: renderProductStock,
      sorter: true,
    },
    {
      title: <TextCenter>ราคาขาย</TextCenter>,
      dataIndex: 'offline_price',
      key: 'offline_price',
      sorter: true,
      render: renderProductPrice,
    },
    // {
    //   title: 'ออฟไลน์',
    //   children: [
    //     {
    //       title: <TextCenter>ราคาขาย</TextCenter>,
    //       dataIndex: 'offline_price',
    //       key: 'offline_price',
    //       sorter: true,
    //       render: renderProductPrice,
    //     },
    //     {
    //       title: <TextCenter>คงเหลือ</TextCenter>,
    //       dataIndex: 'quantity_offline',
    //       key: 'quantity_offline',
    //       sorter: true,
    //       render: renderProductStock,
    //     },
    //   ],
    // },
    {
      title: '',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const GrnHistoryDrawer = (
    <GrnHistory data={selectedStock} visible={grnHistory} onCloseDrawer={() => setGrnHistory(false)} />
  )

  const DetailDrawer = (
    <AdjustDrawer
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
      stockData={selectedStock}
      currentTab={activeTab}
    />
  )

  const StockMoveMentDrawer = (
    <StockMovement
      id={selectedID}
      visible={stockMoveMentDrawer}
      onCloseDrawer={() => setStockMoveMentDrawer(false)}
      onSuccess={() => {}}
      stockData={selectedStock}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="middle" gutter={[8, 8]}>
        <Col xs={24} md={24}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={8}>
              <SearchInput
                placeholder="ค้นหาชื่อ หรือรหัสสินค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={searchKeyword}
                onChange={(evt: any): void => setSearchKeyword(evt.target.value)}
              />
            </Col>
            <Col xs={24} md={8}>
              <Category
                placeholder="ค้นหาชื่อหมวดหมู่สินค้า"
                data={filter.categories}
                categories={categories.data}
                handleChange={(val: []) => onFilter('categories', val)}
              />
            </Col>
            <Col xs={24} md={8}>
              <SelectItem
                name={'manufacturer_id'}
                label={''}
                isRequired={true}
                value={filter.manufacturer_id}
                menu={getMenuSelect(manufacturers.data || [])}
                placeHolder={'ค้นหายี่ห้อ'}
                onChange={(val: string): any => onFilter('manufacturer_id', val)}
              />
            </Col>
            {/* <Col>
              <PrimaryButton
                text="ค้นหา"
                btnType="Cancel"
                onClick={onClickSearch}
                disabled={listEvent.IsLoading}
                loading={listEvent.IsLoading}
              />
            </Col> */}
            <Col>
              <PrimaryButton
                icon={<DownloadOutlined />}
                text="รายงานสินค้าคงคลัง"
                btnType="Primary"
                onClick={onExport}
              />
            </Col>
            {/* <Col>
              <PrimaryButton
                btnType="Cancel"
                text="Barcode สินค้า"
                icon={<BarcodeOutlined />}
                onClick={onExportBarcode}
              />
            </Col> */}
          </Row>
        </Col>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const getTab = () => {
    return (
      <StickyHeader>
        <Tabs onChange={onChangeTab} activeKey={filter.status}>
          {menuStock.map((item: any) => {
            if (item.value === 'min_of_stock') {
              return (
                <TabPane
                  tab={
                    <div>
                      {item.name}&nbsp;
                      <Badge count={stockNotice?.qty || 0} showZero={false} overflowCount={9999}></Badge>
                    </div>
                  }
                  key={item.value}
                ></TabPane>
              )
            } else {
              return <TabPane tab={item.name} key={item.value}></TabPane>
            }
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  const AlertStock = (
    <>
      <br />
      <Alert
        message={<div>คุณยังไม่ได้ทำการตั้งค่าการแจ้งเตือนสต๊อกขั้นต่ำของร้าน &nbsp;</div>}
        description={
          <div>
            <a href="/stock-config" target="_blank">
              คลิกเพื่อตั้งค่าแจ้งเตือนสต๊อกขั้นต่ำ
            </a>
          </div>
        }
        type="warning"
        closable
      />
      <br />
    </>
  )

  return (
    <>
      <HomePageLayout selected="stock" title="รายงานสินค้าคงคลัง" label="">
        {productSelect?.barcode && (
          <Row ref={printPDF}>
            <Col span={24}>
              <BarcodePDF
                barcode={uomSelect?.barcode || ''}
                title={`${productSelect?.product_title || ''}`}
                price={uomSelect?.offline_price || 0}
                configData={config}
                uom={`${uomSelect?.uom_name}`}
              />
            </Col>
          </Row>
        )}
        <LoadingView isShow={exporting} />
        {getTab()}
        {FilterContent}
        {filter.status === 'min_of_stock' && !hasConfig && AlertStock}
        <TableListPage
          columns={enableProductOnline ? columns : columnsWithOutOnline}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          // size="small"
          bordered={true}
          rowKey="product_option_id"
          onSort={onSort}
        />
        {LoadingModal}
        {GrnHistoryDrawer}
        {ConfirmDeleteModal}
        {DetailDrawer}
        {StockMoveMentDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectStockList(state),
    listEvent: selectStockListEvent(state),
    event: selectStockActionEvent(state),
    categories: selectCateList(state),
    manufacturers: selectManufactuerList(state),
    stockNotice: selectCountData(state),
    stockConfigDetail: selectStockConfigDatail(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 60px;
  height: 60px;
  object-fit: cover;
`

const StockMin = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const TextCenter = styled.div`
  text-align: center;
`

const ProductDesc = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const DownloadTxt = styled.div`
  .ant-btn {
    font-size: 12px;
  }
`

const BarcodeWraper = styled.div`
  text-align: center;
  width: 100%;
  // border: 1px solid #000;
  border-radius: 5px;
  margin: 0 auto;
  padding: 5px 0px;
  svg {
    width: 110px !important;
    height: 50px !important;
  }
`

const ProductName = styled.div`
  font-size: 12px;
  font-family: arial;
  font-style: normal;
  color: #000;
`

const ProductPrice = styled.div`
  font-size: 12px;
  font-family: arial;
  font-style: normal;
  color: #000;
`

const PopoverContent = styled.div`
  width: 300px;
  max-width: 100%;
  text-align: center;
  cursor: pointer;
`

export default connect(mapStateToProps)(Stock)
